import React from "react";
import { motion } from "framer-motion";
import { InfoIcon } from "lucide-react";
import { HandArrow } from "../brand/HandArrow";
import { CourtLines } from "../brand/CourtLines";
import { YearTrack } from "./YearTrack";
import { phases } from "../../data/content";
export function RouteSection() {
  return <section aria-labelledby="route-title" className="on-light relative overflow-hidden border-y border-navy/10 bg-white" data-id="element-217" data-mp="3gz5d48zoi0hm">
      <CourtLines className="pointer-events-none absolute -bottom-64 -left-48 h-[640px] w-[640px] text-cyan/15" data-id="element-218" data-mp="3lwoo9012xx5c" />
      <div className="container-x relative py-14 sm:py-20 lg:py-28" data-id="element-219" data-mp="3qye3krvc4wz8">
        <div className="grid items-end gap-6 lg:grid-cols-12" data-id="element-220" data-mp="3uz6erqnrpby5">
          <div className="lg:col-span-7" data-id="element-221" data-mp="3rbpnhqv0vuh">
            <p className="eyebrow" data-id="element-222" data-mp="3r1y3pq62gmo">A clear route through the unit</p>
            <h2 id="route-title" className="section-title mt-4" data-id="element-223" data-mp="20knapjnkv0e0">
              From first skills. <span className="text-navy underline decoration-cyan decoration-[4px] underline-offset-[6px]" data-id="element-224" data-mp="25iorfxxj6nmb">To small-sided play.</span>
            </h2>
          </div>
          <p className="max-w-[30rem] text-[16px] leading-[1.7] text-body sm:text-[17px] lg:col-span-5" data-id="element-225" data-mp="2l8qktiwmil3h">
            Twelve lessons build from first routines and stick control toward teamwork, decision-making and modified games.
          </p>
        </div>

        <YearTrack data-id="element-226" data-mp="27gacc2kyduv6" />

        <ol className="mt-12 grid gap-6 sm:mt-14 lg:mt-20 lg:grid-cols-3 lg:gap-0" data-id="element-227" data-mp="27gsips1bxpgt">
          {phases.map((phase, i) => <motion.li key={phase.number} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-80px"
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1],
          delay: i * 0.06
        }} className="relative border-b border-navy/10 pb-8 last:border-b-0 lg:border-b-0 lg:pb-0 lg:pr-10" data-id="element-228" data-mp="3435jt8ixqdrb" data-mpi={i}>
              <div className="flex items-end gap-4 lg:items-center" data-id="element-229" data-mp="1eqtkp755qi00">
                <span aria-hidden="true" className="font-display text-[64px] font-extrabold leading-[0.82] text-cyan-deep sm:text-[112px] lg:text-[148px]" style={{
              WebkitTextStroke: "1px #2CC4E8"
            }} data-id="element-230" data-mp="1esmw0zqptqec">
                  {phase.number}
                </span>
                <h3 className="font-display text-[26px] font-bold uppercase leading-[0.95] text-navy lg:hidden" data-id="element-231" data-mp="1c5vo9xi8t9xe">
                  <span className="sr-only" data-id="element-232" data-mp="xgptclqfu5vb">Phase {i + 1}: </span>
                  {phase.title}
                </h3>
                <span className="hidden h-px flex-1 bg-navy/15 lg:block" aria-hidden="true" data-id="element-233" data-mp="128zku677bdzp" />
                {i < phases.length - 1 && <HandArrow className="hidden h-8 w-16 shrink-0 text-orange lg:block" data-id="element-234" data-mp="oi48gjxhuerd" />}
              </div>
              <h3 className="mt-6 hidden font-display text-[34px] font-bold uppercase leading-none text-navy lg:block" data-id="element-235" data-mp="sieflzx0vb7t">
                <span className="sr-only" data-id="element-236" data-mp="ekpxgzucai6g">Phase {i + 1}: </span>
                {phase.title}
              </h3>
              <p className="mt-4 max-w-[22rem] text-[15px] leading-relaxed text-body sm:text-base lg:mt-3" data-id="element-237" data-mp="3w0sqnybia298">{phase.summary}</p>
              <ul className="mt-5 flex flex-wrap gap-2 lg:mt-6 lg:block lg:max-w-[22rem] lg:border-t lg:border-navy/15" data-id="element-238" data-mp="3r2r5n7uirsv4">
                {phase.focus.map(item => <li key={item} className="flex items-center gap-2 rounded-[6px] border border-navy/10 bg-ice px-3 py-2 text-[13px] font-semibold text-body lg:gap-3 lg:rounded-none lg:border-0 lg:border-b lg:bg-transparent lg:px-0 lg:py-3 lg:text-[15px]" data-id="element-239" data-mp="4urflprjj8nl">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-orange" aria-hidden="true" data-id="element-240" data-mp="skve5ipvgi7q" />
                    {item}
                  </li>)}
              </ul>
            </motion.li>)}
        </ol>

        <p className="mt-10 flex max-w-[44rem] items-start gap-2.5 text-[13px] leading-relaxed text-body sm:mt-14 sm:text-sm" data-id="element-241" data-mp="11ljskej6gkl5">
          <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-242" data-mp="xhlt22pxx7rk" />
          Start with routines and control, then build toward modified games. Adapt space, equipment and pacing to your learners.
        </p>
      </div>
    </section>;
}